import { ISOCountryCode } from '@pmi.web/countries';
import { TextInput } from '@pmi.web/react-inputs';
import { get, has } from 'lodash-es';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DefaultCountryAddress } from "../_default/DefaultCountryAddress";

export function JPCountryAddress({
  env,
  isoCountryCode,
  required,
}: {
  readonly required: boolean;
  readonly isoCountryCode: ISOCountryCode;
  readonly env: 'development' | 'production';
}) {
  const { t } = useTranslation();
  const {
      register,
      formState: { errors },
    } = useFormContext();

  return (
    <>
    <TextInput
        label={t('Building/Apartment Name')}
        {...register('address.addressLine2')}
        errors={
          has(errors, 'address.addressLine2')
            ? [get(errors, 'address.addressLine2')?.message?.toString() ?? '']
            : []
        }
      />
      <DefaultCountryAddress env={env} isoCountryCode={isoCountryCode} required={required} />
    </>
  );
}
